import { combineReducers } from 'redux'

import asin from './asin'

export default combineReducers({ asin })
